import { Fit } from "@seneca/image-service-client";

import { getDimensionFromCSSVar } from "seneca-common/utils/functions";

import type { ModuleDeviceRequirements } from "features/module/types";

import styles from "./components/common.module.scss";

export const DEVICE_REQUIREMENTS: ModuleDeviceRequirements = {
  minModuleWidth: 300,
  desktopOnly: false
};

export const assetParameters = {
  default: {
    height: getDimensionFromCSSVar(styles.defaultimageHeight),
    fit: Fit.COVER
  }
};

export const controlBarProps = { notSubmitted: "Choose an image" };
